import styles from './ModalChangePassword.module.css';

import Modal from 'react-responsive-modal';

import { Button } from '../../../../components/Button';
import { Input } from '../../../../components/forms/Input';
import { Notify } from '../../../../components/Notify';
import { useForm } from 'react-hook-form';
import { useAuth } from '../../../../hooks/useAuth';
import { api } from '../../../../server/api';

interface FormValues {
  currentPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}

interface IModalChangePassword {
  modalPasswordIsOpen: boolean;
  toggleModalPassword: () => void;
}

export function ModalChangePassword({
  modalPasswordIsOpen,
  toggleModalPassword,
}: IModalChangePassword) {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<FormValues>();

  const { player } = useAuth();

  const handleFormSubmit = handleSubmit(async (formData) => {
    try {
      const parameters = {
        userType: 'player',
        searchFunctionality: 'updatePassword',
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword,
        confirmNewPassword: formData.confirmNewPassword,
        playerId: player.id,
      };

      const response = await api.post<any>('/search', parameters);

      if (!response.data.success) {
        Notify(response.data.message, 'error');
        return;
      }

      Notify(response.data.message, 'success');
      toggleModalPassword();
    } catch (error) {
      console.log('error handleFormSubmit', error);
    }
  });

  return (
    <Modal open={modalPasswordIsOpen} onClose={toggleModalPassword} center>
      <form onSubmit={handleFormSubmit}>
        <div className="contents-modal">
          <h1 className="title-modal">Criar nova senha!</h1>
          <p className="subtitle-modal">
            Crie uma nova senha para acessar sua conta a partir das informações
            atuais de login e senha.
          </p>
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 mb-12 mb-3">
              <Input
                placeholder="Senha atual"
                type="password"
                {...register('currentPassword', {
                  required: true,
                })}
                aria-invalid={errors.currentPassword ? 'true' : 'false'}
                errors={
                  errors.currentPassword
                    ? 'Campo de senha atual obrigatório'
                    : ''
                }
              />
            </div>
            <div className="col-12 col-sm-12 col-md-12 mb-12 mb-3">
              <Input
                placeholder="Nova senha"
                type="password"
                {...register('newPassword', {
                  required: true,
                })}
                aria-invalid={errors.newPassword ? 'true' : 'false'}
                errors={
                  errors.newPassword ? 'Campo de nova senha obrigatório' : ''
                }
              />
            </div>
            <div className="col-12 col-sm-12 col-md-12 mb-12 mb-3">
              <Input
                placeholder="Confirmar nova senha"
                type="password"
                {...register('confirmNewPassword', {
                  required: true,
                })}
                aria-invalid={errors.confirmNewPassword ? 'true' : 'false'}
                errors={
                  errors.confirmNewPassword
                    ? 'Campo de confirmar nova senha obrigatório'
                    : ''
                }
              />
            </div>
          </div>
        </div>
        <div className={styles.contentBtn}>
          <Button
            isModal
            text={isSubmitting ? 'Alterando' : 'Alterar senha'}
            type="submit"
            color="primary"
            isLoading={isSubmitting}
            disabled={isSubmitting}
          />
        </div>
      </form>
    </Modal>
  );
}
